import React, { useContext, useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import { AgendaContext } from '../context/AgendaContext';
import InfoForm from './forms/InfoForm';
import DocActionMenu from './DocActionMenu';
import ToggleForm from './ToggleForm';
import { DocsWrapper, TableColumn } from '../styles/TableStyle';
import { useTranslation } from 'react-i18next';

const ClcInfo = () => {
const { t } = useTranslation(); 
const { clcInfoDocs, setClcInfoDocs } = useContext(AgendaContext)

    const dynamicFields = [
        { type: 'text', label: t('common.formLabels.reference.name'), name: 'reference', placeholder: t('common.formLabels.reference.label'), required: true },
        {type: 'textarea', label: t('common.formLabels.title.name'), name: 'title', placeholder: t('common.formLabels.title.label'), required: true},
        {type: 'date', label: t('infoDocs.formLabels.published.name'), name: 'published_date', placeholder:t('infoDocs.formLabels.published.label'), required: true}, 
    ]

    const [editItem, setEditItem] = useState({ id: null, reference: '', title: '', published_date: '', document_links: [{ fileName: '', url: '' }, { fileName: '', url: '' }] });
    const [newTask, setNewTask] = useState({ id: null, reference: '', title: '', published_date: '', document_links: [{ fileName: '', url: '' }, { fileName: '', url: '' }] });

    useEffect(() => {
        localStorage.setItem('clc_info_docs', JSON.stringify(clcInfoDocs));
    }, [clcInfoDocs]);

    const handleEditCancel = () => {
        setEditItem(prev => ({
            ...prev,
            id: null
        }))
    };

    const handleNewTaskChange = (event) => {
        const { name, value } = event.target;

        if (name.startsWith('document_links')) {
            const index = parseInt(name.split('.')[1], 10);
            const updatedLinks = [...newTask.document_links];
            const property = name.split('.')[2]; // This will either be 'fileName' or 'url'
            updatedLinks[index] = { ...updatedLinks[index], [property]: value };
            setNewTask({ ...newTask, document_links: updatedLinks });
        } else {
            setNewTask({ ...newTask, [name]: value });
        }
    };

    const handleEditTaskChange = (event) => {
        const { name, value } = event.target;

        if (name.startsWith('document_links')) {
            const index = parseInt(name.split('.')[1], 10);
            const updatedLinks = [...editItem.document_links];
            const property = name.split('.')[2]; // This will either be 'fileName' or 'url'
            updatedLinks[index] = { ...updatedLinks[index], [property]: value };
            setEditItem({ ...editItem, document_links: updatedLinks });
        } else {
            setEditItem({ ...editItem, [name]: value });
        }
    };

    const handleSubmitNewTask = (event) => {
        event.preventDefault();
        const { reference, title, published_date, document_links } = newTask;

        setClcInfoDocs((prevItems) => [
            ...prevItems,
            {
                id: uuidv4(),
                reference: reference,
                title: title,
                published_date: published_date,
                document_links: document_links
            },
        ]);
        setNewTask({ id: null, reference: '', title: '', published_date: '', document_links: [{ fileName: '', url: '' }, { fileName: '', url: '' }] });
    };

    const handleSubmitEditTask = (event) => {
        event.preventDefault();
        const { reference, title, published_date, document_links } = editItem;

        setClcInfoDocs((prevItems) =>
            prevItems.map((item) =>
                item.id === editItem.id
                    ? { ...item, title, reference, published_date, document_links }
                    : item
            )
        )

        setEditItem({ id: null, reference: '', title: '', published_date: '', document_links: [{ fileName: '', url: '' }, { fileName: '', url: '' }] });
    }

    const handleEditTextClick = (item) => {
        setEditItem({
            id: item.id,
            reference: item.reference,
            title: item.title,
            published_date: item.published_date,
            document_links: item.document_links,
        })
    }

    const handleDeleteText = (id) => {
        const deleteItems = clcInfoDocs.filter((item) => item.id !== id)
        setClcInfoDocs(deleteItems)
        localStorage.setItem('clc_action_docs', JSON.stringify(deleteItems))
    }

    return (
        <div>
            <div>
                {clcInfoDocs && clcInfoDocs.length > 0 ? (
                    <DocsWrapper $type='information_docs'>
                        <div>
                            <span>{t('common.formLabels.reference.name')}</span>
                            <span>{t('infoDocs.formLabels.published.name')}</span>
                            <span></span>
                        </div>
                        {clcInfoDocs.map((item, index) => (
                            <div key={item.id}>
                                {editItem.id === item.id ? (
                                    <InfoForm
                                        item={editItem}
                                        setItem={setEditItem}
                                        handleOnChange={handleEditTaskChange}
                                        handleSubmit={handleSubmitEditTask}
                                        handleEditCancel={handleEditCancel}
                                        docs={clcInfoDocs.length}
                                        dynamicFields={dynamicFields}
                                        title={`${t('common.edit')} ${t('infoDocs.clcDocument')} #${index + 1}`}
                                        buttonColorTheme='lightBlue'
                                        isEditing={editItem.id === item.id}
                                    />
                                ) : (
                                    <>
                                        <TableColumn>
                                            <p>{item.reference}</p>
                                            <div>
                                                {item.document_links && item.document_links.map((link, linkIndex) => (
                                                    <a key={linkIndex} href={link.url} target='_blank' rel='noopener noreferrer'>{link.fileName}</a>
                                                ))}
                                            </div>
                                            <p>{item.title}</p>
                                        </TableColumn>
                                        <span>{new Date(item?.published_date).toLocaleDateString()}</span>
                                        <span>
                                            <DocActionMenu 
                                                item={item}
                                                handleDeleteText={handleDeleteText}
                                                handleEditTextClick={handleEditTextClick}
                                            />
                                        </span>
                                    </>
                                )}
                            </div>
                        ))}
                    </DocsWrapper>
                ) : (
                    <span>{t('common.noDocuments')}</span>
                )}
            </div>
            <ToggleForm>
                <InfoForm
                    item={newTask}
                    setItem={setNewTask}
                    handleOnChange={handleNewTaskChange}
                    handleSubmit={handleSubmitNewTask}
                    dynamicFields={dynamicFields}
                    title={`${t('common.addBtnLabel')} ${t('infoDocs.clcDocument')}`}
                    buttonColorTheme='darkBlue'
                />
            </ToggleForm>
        </div>
    );
}

export default ClcInfo